/* istanbul ignore file */

// ported from monolith
import React, { PureComponent } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import logger from '../../../../lib/logger';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

export default class ColumnLayout extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    element: PropTypes.string,
    firstIndexOnMobile: PropTypes.number,
    widths: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  };

  static defaultProps = {
    className: null,
    element: 'div',
    firstIndexOnMobile: 0,
  };

  componentDidUpdate(prevProps) {
    const { children, widths } = this.props;
    if (process.env.NODE_ENV === 'development') {
      if (children !== prevProps.children || widths !== prevProps.widths) {
        this.validateProps();
      }
    }
  }

  getRootClasses() {
    const { className } = this.props;

    return cx({
      [className]: className !== null,
      [styles.Root]: true,
    });
  }

  getColumnClasses(index) {
    const { firstIndexOnMobile } = this.props;
    return cx({
      [styles.Column]: true,
      [styles.isFirstOnMobile]: index === firstIndexOnMobile,
    });
  }

  validateProps() {
    const { children, widths } = this.props;

    if (React.Children.count(children) !== widths.length) {
      logger('ColumnLayout').warn({
        expected: widths.length,
        actual: React.Children.count(children),
      },
      'You passed the wrong number of children to ColumnLayout');
    }
  }

  render() {
    const { children, widths, element } = this.props;

    const Element = element;
    const childrenAsArray = React.Children.toArray(children);

    return (
      <Element className={ this.getRootClasses() }>
        {widths.map((width, index) => {
          return (
            <div
              className={ this.getColumnClasses(index) }
              key={ childrenAsArray[index].key }
              style={{ width: `${width}%` }}
            >
              { childrenAsArray[index] }
            </div>
          );
        })}
      </Element>
    );
  }
}
